import { ApiRoutesNames } from "../api/routes"

export enum Authorizations {
  sysadmin = 1, // PODE TUDO
  eventsAll = 2, // MANIPULAR JOGOS
  usersAll = 3, // MAINUPULAR USUARIOS E GRUPOS DE USUARIOS
  usersOnlyOwnData = 4, // MANIPULAR OS DADOS DO PROPRIO USUARIO
  tasksAll = 5, // MANIPULAR AS TAREFAS
  tasksExecOnly = 6, // APENAS EXECUTAR AS TAREFAS
  betsAll = 7, // MANIPULAR APOSTAS
  tasksMoreThanOnceDb = 8, // EXECUTAR AS TAREFAS EM MAIS DE UM BANCO AO MESMO TEMPO
  tasksRead = 9, // APENAS CONSULTAR TAREFAS
  companiesAll = 10, // MANIPULAR EMPRESAS E GRUPOS DE EMPRESAS
}

export interface IEndpointAuthMeta {
  method: string,
  endpoint: string,
  auths: number[],
}

export const endpoinstAuths: IEndpointAuthMeta[] = [
  // COMPANIES GROUPS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.companiesGroups,
    auths: [Authorizations.sysadmin, Authorizations.companiesAll]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.companiesGroups,
    auths: [Authorizations.sysadmin, Authorizations.companiesAll]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.companiesGroups,
    auths: [Authorizations.sysadmin, Authorizations.companiesAll]
  },

  // COMPANIES
  {
    method: 'POST',
    endpoint: ApiRoutesNames.companies,
    auths: [Authorizations.sysadmin, Authorizations.companiesAll]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.companies,
    auths: [Authorizations.sysadmin, Authorizations.companiesAll]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.companies,
    auths: [Authorizations.sysadmin, Authorizations.companiesAll]
  },

  // SPORTS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.sports,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.sports,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.sports,
    auths: [Authorizations.sysadmin]
  },

  // LOCATIONS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.locations,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.locations,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.locations,
    auths: [Authorizations.sysadmin]
  },

  // EVENTSTATUS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.eventsStatus,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.eventsStatus,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.eventsStatus,
    auths: [Authorizations.sysadmin]
  },

  // BETSSTATUS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.betsStatus,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.betsStatus,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.betsStatus,
    auths: [Authorizations.sysadmin]
  },

  // AUTHORIZATIONS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.authorizations,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.authorizations,
    auths: [Authorizations.sysadmin]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.authorizations,
    auths: [Authorizations.sysadmin]
  },


  // EVENTS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.events,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.events,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.events,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },

  // PARTICIPANTS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.participants,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.participants,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.participants,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },

  // TOURNAMENTS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.tournaments,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.tournaments,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.tournaments,
    auths: [Authorizations.sysadmin, Authorizations.eventsAll]
  },

  // USERS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.users,
    auths: [Authorizations.sysadmin, Authorizations.usersAll]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.users,
    auths: [Authorizations.sysadmin, Authorizations.usersAll, Authorizations.usersOnlyOwnData]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.users,
    auths: [Authorizations.sysadmin, Authorizations.usersAll]
  },

  // USERSGROUPS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.usersGroups,
    auths: [Authorizations.sysadmin, Authorizations.usersAll]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.usersGroups,
    auths: [Authorizations.sysadmin, Authorizations.usersAll]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.usersGroups,
    auths: [Authorizations.sysadmin, Authorizations.usersAll]
  },


  // BETS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.bets,
    auths: [Authorizations.sysadmin, Authorizations.betsAll]
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.bets,
    auths: [Authorizations.sysadmin, Authorizations.betsAll]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.bets,
    auths: [Authorizations.sysadmin, Authorizations.betsAll]
  },


  // TASKS
  {
    method: 'POST',
    endpoint: ApiRoutesNames.dbTasks,
    auths: [Authorizations.sysadmin, Authorizations.tasksAll]
  },
  {
    method: 'GET',
    endpoint: ApiRoutesNames.dbTasks,
    auths: [Authorizations.sysadmin, Authorizations.tasksAll, Authorizations.tasksRead, Authorizations.tasksExecOnly,],
  },
  {
    method: 'PUT',
    endpoint: ApiRoutesNames.dbTasks,
    auths: [Authorizations.sysadmin, Authorizations.tasksAll]
  },
  {
    method: 'DELETE',
    endpoint: ApiRoutesNames.dbTasks,
    auths: [Authorizations.sysadmin, Authorizations.tasksAll]
  },


  {
    method: 'POST',
    endpoint: ApiRoutesNames.dbTasksUpload,
    auths: [Authorizations.sysadmin, Authorizations.tasksAll]
  },
  {
    method: 'POST',
    endpoint: ApiRoutesNames.dbTasksExec,
    auths: [Authorizations.sysadmin, Authorizations.tasksAll, Authorizations.tasksExecOnly]
  }
]